export default "__VITE_ASSET__Cccf4FiL__"